import { mapMutations } from 'vuex'
import helpers from '../helpers'

export const resourceControl = {
  data () {
    return {
      loading: false,
      dataLoading: false,
      activeId: null,
      labels: {
        name: this.$tc('labels.' + helpers.camelToSnake(helpers.singular(this.$options.name)), 0),
        create: this.$t('labels.action_resource', { action: this.$t('labels.create'), resource: this.$tc('labels.' + helpers.camelToSnake(helpers.singular(this.$options.name)), 1) }),
        edit: this.$t('labels.action_resource', { action: this.$t('labels.edit'), resource: this.$tc('labels.' + helpers.camelToSnake(helpers.singular(this.$options.name)), 1) }),
        delete: this.$t('labels.action_resource', { action: this.$t('labels.delete'), resource: this.$tc('labels.' + helpers.camelToSnake(helpers.singular(this.$options.name)), 1) })
      }
    }
  },
  computed: {
    dataLength () {
      let length = 0
      if (this.resources.data) length = this.resources.data.length
      return Math.max(this.resourceState.tableRows - length, 0)
    }
  },
  mounted () {
    this.index(this.page)
  },
  methods: {
    ...mapMutations([
      'pushState',
      'pushFilter'
    ]),
    find (objects, match, value, key) {
      const obj = this._.find(objects, function (o) { return o[match] === value })
      if (obj && obj[key]) return obj[key]
      return null
    },
    applySort (val) {
      this.pushState({ view: this.$options.name, key: 'sort', data: val })
      this.index()
    },
    handleState (page, count, filters) {
      if (page) this.pushState({ view: this.$options.name, key: 'page', data: page })
      if (count) this.pushState({ view: this.$options.name, key: 'tableRows', data: count })
      if (filters) this.pushFilter({ view: this.$options.name, data: filters })
    },
    index (page, count, filters) {
      this.handleState(page, count, filters)
      this.loading = true
      this.$store.dispatch('index', { collection: this.$options.name }).then(() => {
        this.loading = false
      })
    },
    create () {
      this.$store.commit('axiosError', null)
      this.$root.clearData(this.resource)
      this.$modal.show('create-' + this.$options.name)
    },
    destroy (o) {
      this.activeId = o.id
      this.$modal.show('destroy-' + this.$options.name)
    },
    update (o) {
      this.$store.commit('axiosError', null)
      this.resource = JSON.parse(JSON.stringify(o))
      this.$modal.show('create-' + this.$options.name)
    },
    submit () {
      this.$store.dispatch(this.resource.id ? 'update' : 'store', { collection: this.$options.name, resource: this.resource }).then(() => {
        this.$modal.hide('create-' + this.$options.name)
      })
    },
    destruction () {
      this.$store.dispatch('destroy', { collection: this.$options.name, id: this.activeId }).then(() => {
        this.$modal.hide('destroy-' + this.$options.name)
      })
    }
  }
}
